module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewMapIcon.svg?c2a5ba6d";